import React, { Component } from 'react';
import {connect} from "react-redux";
import '../css/account-setting-page.css';
import {TIER_DISPLAYED_NAME, PRICE_TAG_BY_TIER, TIER_DESCRIPTION, TIER_RANKS_PREFIX} from "./subscription-container";
import {bindActionCreators} from "redux";
import {startFetchingInvoiceList} from "../actions/getSubscriptions";
import {changeTabPage} from "../actions/getProfile";
import SubscriptionPage from "./subscription-container";
import {wrappedWithStripe} from "./tabbed_content";
import LoadingAnimation from '../components/loading-animation';
import EmailSubscribe from './email-subscribe';
import PrintRecordSharing from './print_record_sharing';
import { startFetchingEmailSubscriptionStatus } from "../actions/getSubscriptions";
import { startTogglePrintStatusEmail } from "../actions/getSubscriptions";
import { startFetchingPrintRecordSharingStatus, startTogglePrintRecordSharing } from "../actions/getPrintRecordSharingStatus";

class AccountSettingPage extends Component {
  toggleEmailSubscribe = () => {
    const { emailSubscribeStatus, emailSubscribeToggleable } = this.props;
    if (!emailSubscribeToggleable) {
      return;
    }
    this.props.startTogglePrintStatusEmail(emailSubscribeStatus)
  };
  togglePrintRecordSharing = () => {
    const { printRecordSharingStatus, printRecordSharingToggleable } = this.props;
    if (!printRecordSharingToggleable) {
      return;
    }
    this.props.startTogglePrintRecordSharing(printRecordSharingStatus)
  }
  render() {
    const { nickname, email } = this.props.userProfile;
    const { subscribedTierRank, subscribedPlanFullName,
      loadingSubscriptionList, changeTabPage, emailSubscribeStatus, emailSubscribeToggleable, printRecordSharingStatus, printRecordSharingToggleable } = this.props;
    return <div>
      { loadingSubscriptionList ? <LoadingAnimation/> :
        <div>
          <AccountInfoContainer nickname={nickname} email={email}/>
          <hr className='setting-hr'/>
          <div className='upper-section'>
            <PrintRecordSharing currentStatus={printRecordSharingStatus}
              printRecordSharingToggleable={printRecordSharingToggleable}
              togglePrintRecordSharing={this.togglePrintRecordSharing}/>
            <EmailSubscribe currentStatus={emailSubscribeStatus}
              emailSubscribeToggleable={emailSubscribeToggleable}
              toggleEmailSubscribe={this.toggleEmailSubscribe}/>
          </div>
          <hr className='setting-hr'/>
          { wrappedWithStripe(<SubscriptionPage/>) }

        </div>
      }
    </div>
  }

  componentDidMount() {
    this.props.startFetchingPrintRecordSharingStatus();
    this.props.startFetchingInvoiceList();
    this.props.startFetchingEmailSubscriptionStatus();
  }
}


export const EMAIL_SUBSCRIBE_STATUS = {
  ON: 'on',
  OFF: 'off'
};

export const PRINT_RECORD_SHARING_STATUS = {
  ON: 'on',
  OFF: 'off'
}

/**
 * top-left account info section
 */
const AccountInfoContainer = ({ nickname, email }) => {
  return (
    <div className='upper-section-title'><i className='material-icons' style={{ 'padding': '5px' }}>account_circle</i>{email}</div>
  )
}


/**
 * Redux connection
 */
const mapStateToProps = state => ({
  userProfile: state.userProfile.profile,
  ...state.subscriptions,
  ...state.printRecordSharing
})
const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    startFetchingInvoiceList,
    changeTabPage,
    startFetchingEmailSubscriptionStatus,
    startTogglePrintStatusEmail,
    startFetchingPrintRecordSharingStatus,
    startTogglePrintRecordSharing
  }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(AccountSettingPage);



// WEBPACK FOOTER //
// ./src/containers/account-setting-container.js